// INITIAL STATE
// ==========================================================================

export const initialState = {
  currentLayout: 'Main', // 'project' || 'sensitivity'
  // Project
  projectIds: [],
  projectsById: {},

  // Current Selection
  selectedProjectIds: [],
  selectedCasingIds: [],
  selectedPlugIds: [],
  selectedZoneIds: [],

  // Project Input Data
  inputGeneralByProjectId: {},
  inputPressureByProjectId: {},
  inputPlugProgramByProjectId: {},
  inputCasingProgramByProjectId: {},
  inputZoneProgramByProjectId: {},

  // Project Output Data
  outputPlugProgramByProjectId: {},
  outputSummaryByProjectId: {},
  outputDetailByProjectId: {},
  outputTimeSeriesByProjectId: {},
  outputSpaceByProjectId: {},
  // Settings
  settings: {}
};

export default initialState;
